/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Link } from 'gatsby';

import { UNSAFE_media } from '@atlaskit/primitives/responsive';
import { N10, N300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

const footerStyles = css({
  backgroundColor: token('color.background.neutral', N10),
  gridArea: 'footer',
});
const footerNavStyles = css({
  display: 'flex',
  paddingBlockStart: token('space.300', '24px'),
  paddingInlineEnd: token('space.1000', '80px'),
  paddingBlockEnd: token('space.300', '24px'),
  paddingInlineStart: token('space.1000', '80px'),
  justifyContent: 'center',
  gap: token('space.400', '32px'),
  color: token('color.text.subtlest', N300),
  fontSize: token('font.size.075', '12px'),
  a: {
    color: token('color.text.subtlest', N300),
  },
  [UNSAFE_media.below.sm]: {
    gap: token('space.100', '8px'),
    flexDirection: 'column',
  },
});

const navLinksStyles = css({
  display: 'flex',
  marginBlockStart: token('space.0', '0'),
  padding: token('space.0', '0'),
  justifyContent: 'center',
  gap: token('space.400', '32px'),
  listStyle: 'none',
  li: {
    display: 'inline-flex',
    marginBlockStart: token('space.0', '0'),
  },
  [UNSAFE_media.below.sm]: {
    gap: token('space.200', '16px'),
  },
});

type FooterProps = {
  id?: string;
};

/**
 * __Footer__
 *
 * The site footer.
 */
const Footer = ({ id }: FooterProps) => {
  return (
    <footer id={id} css={footerStyles}>
      <nav css={footerNavStyles}>
        <p>&copy; {new Date().getFullYear()} Atlassian</p>
        <ul css={navLinksStyles}>
          <li>
            <a
              href="https://www.atlassian.com/company/careers"
              target="_blank"
              rel="noopener"
            >
              Careers
            </a>
          </li>
          <li>
            <a
              href="https://www.atlassian.com/legal/trademark"
              target="_blank"
              rel="noopener"
            >
              Trademark
            </a>
          </li>
          <li>
            <a
              href="https://www.atlassian.com/legal/privacy-policy"
              target="_blank"
              rel="noopener"
            >
              Privacy
            </a>
          </li>
          <li>
            <Link to="/license">License</Link>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
